import classnames from 'classnames';
import SubmitallViewerModal from 'components/modals/SubmittalViewerModal';
import {
  ManageDrawingsSupportContext,
  ManageDrawingsSupportValue,
} from 'providers/ManageDrawingsSupportProvider';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Doc } from 'records/Doc';
import { ModalState } from 'records/ModalState';
import { Page } from 'records/Page';
import { Submittal } from 'records/Submittal';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps, RouteComponentProps {
  doc: Doc;
  submittal: Submittal;
}

interface State {
  imgLoaded: boolean;
}

class SubmittalDocTile extends React.Component<Props, State> {
  state = {
    imgLoaded: false,
  };

  handleDocClick = async (): Promise<void> => {
    // Navigate to Submittal Pages in Viewer.
    // const { history, doc } = this.props;

    // history.push(
    //   `/project/${doc.projectid}/doc/${doc.documentid}/view?page=0`,
    //   { previousLocation: { ...history.location } }
    // );
    const { doc, submittal, actions } = this.props;

    const modalState = new ModalState({
      id: 'SubmittalViewer',
      portal: 'main',
      open: true,
      shouldCloseOnOverlayClick: false,
      shouldCloseOnEsc: false,
      component: SubmitallViewerModal,
      props: {
        doc,
        submittalId: submittal.id,
        showToolbar: true,
      },
    });

    actions.createModal(modalState);
  };

  // Trying to prevent broken img thing from showing.
  handleImgLoaded = (): void => {
    this.setState({ imgLoaded: true });
  };

  render(): React.ReactNode {
    const { doc, appState } = this.props;
    const { pages } = appState;
    const { imgLoaded } = this.state;

    const firstPage = pages
      .valueSeq()
      .filter((p) => p.documentid === doc.documentid)
      .sortBy((p) => p.pageIndex)
      .first<Page>(new Page());

    return (
      <ManageDrawingsSupportContext.Consumer>
        {({ onSuccess }: ManageDrawingsSupportValue) => (
          <div
            className="row b-radius-3 p3 cursor-pointer"
            style={{
              width: '369px',
              backgroundColor: 'var(--white-2)',
              boxShadow: '0 2px 16px 0 rgba(0, 116, 204, 0.08)',
            }}
            onClick={() => onSuccess(() => this.handleDocClick())}
          >
            <div className="wrem-6">
              <img
                onLoad={this.handleImgLoaded}
                className={classnames('w100 h100 of-contain', {
                  hidden: !imgLoaded,
                })}
                src={firstPage.thumbnailUrl}
                alt="attachment page thumbnail"
              />
            </div>
            <div
              className="font-size-5 light ml2 wrap"
              style={{
                color: 'var(--black-2)',
              }}
            >
              {doc.filename}
            </div>
          </div>
        )}
      </ManageDrawingsSupportContext.Consumer>
    );
  }
}

export default withRouter(withAppStore<Props>(SubmittalDocTile));
